type Entity = { documentId: string }

export default function connect(entity?: Entity | Entity[]) {
    if (!entity) return undefined

    if (Array.isArray(entity)) {
        return { connect: entity.map(x => x.documentId) }
    }

    return { connect: [entity.documentId] }
}
